import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';

import "../../App.css";
import "./Forms.css";

import agendaIcon from "../../assets/icons/agenda.png";

import AgendamentosService from "../../services/AgendamentosService";
import CadastrosInternosService from "../../services/CadastrosInternosService";
import EspecialidadesService from "../../services/EspecialidadesService";
import HorariosService from "../../services/HorariosService";

import criarAgendamentoPacoteDTO from "../../types/AgendamentoPacoteDTO";

export default function AgendamentoPacoteForm({ onClose }) {

  const { setRetorno } = useGerenciamento();

  const [form, setForm] = useState({
    idCadastro: "",
    diaSemana: "",
    condicao: "",
    idEspecialidade1: "",
    idEspecialidade2: "",
    idHorario: "",
    repetirPorMeses: 1
  });

  const [clientes, setClientes] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);

  const [diasAtivos, setDiasAtivos] = useState([]);
  const [horariosFiltrados, setHorariosFiltrados] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // ===================================================
  // MAPA DIA SEMANA 
  // ===================================================
  const diasSemanaMap = {
    1: "Segunda",
    2: "Terça",
    3: "Quarta",
    4: "Quinta",
    5: "Sexta",
    6: "Sábado",
    7: "Domingo"
  };

  const condicoes = {
    1: "Mês completo",
    2: "Mês completo alternando especialidade",
    3: "Apenas 4 semanas",
    4: "4 semanas alternando especialidade"
  };

  // ===================================================
  // LOAD BASE DATA
  // ===================================================
  useEffect(() => {

    async function carregarBase() {

      const [cli, esp] = await Promise.all([
        CadastrosInternosService.getAll(),
        EspecialidadesService.getLista()
      ]);

      setClientes(Array.isArray(cli) ? cli : []);
      setEspecialidades(Array.isArray(esp) ? esp : []);

      // dias fixos
      setDiasAtivos([1, 2, 3, 4, 5, 6, 7]);
    }

    carregarBase();

  }, []);

  // ===================================================
  // FILTRAR HORARIOS
  // ===================================================
  async function carregarHorariosPorDia(diaSemana) {

    if (!diaSemana) {
      setHorariosFiltrados([]);
      return;
    }

    const horarios = await HorariosService.getByDiaSemana(diaSemana);

    setHorariosFiltrados(
      Array.isArray(horarios)
        ? horarios
        : Array.isArray(horarios?.data)
          ? horarios.data
          : []
    );
  }

  // ===================================================
  // HANDLE CHANGE
  // ===================================================
  async function handleChange(e) {

    const { name, value } = e.target;

    if (name === "diaSemana") {

      setForm(prev => ({
        ...prev,
        diaSemana: value,
        idHorario: ""
      }));

      await carregarHorariosPorDia(value);
      return;
    }

    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  }

  // ===================================================
  // VALIDACAO
  // ===================================================
  function validarCampos() {

    const e = {};

    if (!form.idCadastro)
      e.idCadastro = "Informe o cliente";

    if (!form.diaSemana)
      e.diaSemana = "Informe o dia";

    if (!form.idHorario)
      e.idHorario = "Informe o horário";

    if (!form.idEspecialidade1)
      e.idEspecialidade1 = "Informe especialidade";

    return e;
  }

  // ===================================================
  // SUBMIT
  // ===================================================
  async function handleSubmit(e) {

    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length > 0) return;

    setLoading(true);

    try {

      const pacoteDTO =
        criarAgendamentoPacoteDTO(form);

      const retorno =
        await AgendamentosService.createPacote(pacoteDTO);

      //console.log("RESULTADO API:", retorno);
      //console.log("Dados enviados ", retorno);

      setRetorno({
        tipo: retorno.success ? "sucesso" : "erro",
        mensagem: retorno.mensagem
      });
        
      onClose();

    } catch (error) {
      //console.log(error.response.data);

      console.error(error);
      setRetorno({
        tipo: "erro",
        mensagem:
          error?.response?.data?.mensagem ||
          error?.response?.data?.erro ||
          error?.message ||
          "Erro ao realizar o agendamento."
      });
      onClose();

    } finally {
      setLoading(false);
    }
  }

  // ===================================================
  // RENDER
  // ===================================================
  return (
    <div className="Form-Interno-Container">

      <form onSubmit={handleSubmit}>

        <div className="Form-Interno-title">
          <img src={agendaIcon} className="icon" />
          Criar Pacote de Agendamentos
        </div>

        <div className="Form-Interno-linha"></div>

        {/* CLIENTE */}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Cliente *</div>

          <select name="idCadastro" value={form.idCadastro} onChange={handleChange}>
            <option value="">Selecione</option>
            {clientes.map(c => (
              <option key={c.IDCADASTRO} value={c.IDCADASTRO}>
                {c.NOME}
              </option>
            ))}
          </select>
        </div>

        {/* DIA */}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Dia da Semana</div>

          <select name="diaSemana" value={form.diaSemana} onChange={handleChange}>
            <option value="">Selecione</option>

            {diasAtivos.map(dia => (
              <option key={dia} value={dia}>
                {diasSemanaMap[dia]}
              </option>
            ))}
          </select>
        </div>

        {/* CONDIÇÃO */}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Condição</div>

          <select name="condicao" value={form.condicao} onChange={handleChange}>
            <option value="">Selecione</option>

            {Object.entries(condicoes).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>

        {/* ESPECIALIDADE 1 */}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Especialidade 1</div>

          <select name="idEspecialidade1" value={form.idEspecialidade1} onChange={handleChange}>
            <option value="">Selecione</option>

            {especialidades.map(e => (
              <option key={e.IDESPECIALIDADE} value={e.IDESPECIALIDADE}>
                {e.DESCRICAO}
              </option>
            ))}
          </select>
        </div>

        {/* ESPECIALIDADE 2 */}
        { (form.condicao === '2' || form.condicao === '4') && (
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Especialidade 2</div>

          <select name="idEspecialidade2" value={form.idEspecialidade2} onChange={handleChange}>
            <option value="">Opcional</option>

            {especialidades.map(e => (
              <option key={e.IDESPECIALIDADE} value={e.IDESPECIALIDADE}>
                {e.DESCRICAO}
              </option>
            ))}
          </select>
        </div>
        )}


        {/* HORARIO */}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Horário</div>

          <select name="idHorario" value={form.idHorario} onChange={handleChange}>
            <option value="">Selecione</option>

            {horariosFiltrados.map(h => (
              <option key={h.IDHORARIO} value={h.IDHORARIO}>
                {h.HORARIO.slice(0,5)}h
              </option>
            ))}
          </select>
        </div>

        {/* MESES */}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Repetir por meses</div>

            <input
              type="number"
              min="1"
              max="12"
              name="repetirPorMeses"
              value={form.repetirPorMeses}
              onChange={handleChange}
            />
        </div>

        <div className="Form-Interno-alinhamento-button">
          <button className="Form-Interno-button" disabled={loading}>
            {loading ? "Salvando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>

      </form>
    </div>
  );
}